import { BffCmsPromotionResponse, CmsPromoVisibility } from '@lucky7ventures/bff-types';

export const filterPromotionSlugs = (params: {
  slugs: string[];
  promotions: Record<string, BffCmsPromotionResponse>;
  isAuthenticated: boolean;
  userTags: string[];
}): string[] => {
  const { slugs, promotions, isAuthenticated, userTags } = params;
  return slugs.reduce((acc: string[], slug) => {
    const promotion = promotions[slug];
    if (promotion) {
      // 1. visibility - depends on the logged in status of the user
      // if the promotion is visible only to logged out users, and the user is logged in, skip
      if (promotion.visibility === CmsPromoVisibility.LoggedOut && isAuthenticated) {
        return acc;
      }
      // if the promotion is visible to only logged in users, and the user is logged out, skip
      if (promotion.visibility === CmsPromoVisibility.LoggedIn && !isAuthenticated) {
        return acc;
      }

      // 2. excluded tags - if the promotion has excluded tags, and the user has one of those tags, skip
      if (
        promotion.excludedTags.length > 0 &&
        userTags.some(tag => promotion.excludedTags.includes(tag))
      ) {
        return acc;
      }

      // 3. exclusive tags - if the promotion has exclusive tags, and the user doesn't have at least one of those tags, skip
      if (
        promotion.exclusiveTags.length > 0 &&
        !userTags.some(tag => promotion.exclusiveTags.includes(tag))
      ) {
        return acc;
      }

      acc.push(promotion.slug);
    }
    return acc;
  }, []);
};
